module.exports = __webpack_public_path__ + "static/media/HCMM391.8b173633.jpg";